import { render, staticRenderFns } from "./admin_corner_icon.vue?vue&type=template&id=3397ae3d&functional=true&"
import script from "./admin_corner_icon.vue?vue&type=script&lang=js&"
export * from "./admin_corner_icon.vue?vue&type=script&lang=js&"
import style0 from "./admin_corner_icon.vue?vue&type=style&index=0&id=3397ae3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports